import { Identifier } from "../../core";
export class MenuSectionItemId extends Identifier {
    constructor(id) {
        super("MenuSectionItemId", id);
    }
}
